/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Patient/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import Addresses from './Addresses/index'
import BackAction from './BackAction/index'
import CloseAction from './CloseAction/index'
import Details from './Details/index'
import Emails from './Emails/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import Phones from './Phones/index'
import React from 'react'
import Relationship from './Relationship/index'
import SaveAction from './SaveAction/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Patient({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/Patient"
  
}) {
let editRelationFromPersonRecordFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation',
path: 'from_person_record.first_name',
})
let editRelationFromPersonRecordLastNameValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation',
path: 'from_person_record.last_name',
})
let aggregateData = fromAggregate.join(editRelationFromPersonRecordFirstNameValueData, editRelationFromPersonRecordLastNameValueData)
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
>
{childProps => (
<div
  data-testid="Patient.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Patient.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 data="edit_relation.from_person_record.first_name"
 data="edit_relation.from_person_record.last_name"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Relationship
  viewPath={`${viewPath}/Relationship`}
/>
<Details
  viewPath={`${viewPath}/Details`}
/>
<Addresses
  viewPath={`${viewPath}/Addresses`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<Phones
  viewPath={`${viewPath}/Phones`}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
/>
<Emails
  viewPath={`${viewPath}/Emails`}
/>
<div
  data-testid="Patient.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}